{
  "shared": {
    "money": {
      "roundingVariance": "تفاوت التقريب"
    }
  }
}
